import * as React from 'react';

import AdminSyncTypePickerContainer from 'admin/rostering/components/AdminSyncTypePickerContainer';
import AdminSyncTypeCleverView from 'admin/rostering/components/AdminSyncTypeCleverView';
import Button from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import Container from 'components/Container';
import Dialog from 'components/Dialog';
import Heading from 'components/Heading';
import Row from 'components/Row';
import SyncSetupView from 'syncSetup/components/SyncSetupView';
import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';
import WizardHeader from 'components/WizardHeader';
import { SyncType } from 'globalTypes';
import ModalTrigger from 'components/ModalTrigger';
// @ts-ignore
import SupportDialog from 'support/components/SupportDialog';

type Props = {
  orgName: string;
  selectSyncType: (method: SyncType) => void;
  onClose: () => void;
};

type State = {
  syncType: SyncType;
};

class AdminSyncTypePickerModal extends React.Component<Props, State> {
  state = {
    syncType: SyncType.classlink,
  };

  renderHeaderWithIcon = () => {
    return (
      <WizardHeader>
        <TextWithIcon
          data-test="sync-type-picker-header-icon"
          icon="arrows-circle-square"
          iconColor="atlas"
          iconSize="large"
          color="chalkboard"
          size="large">
          SIS sync setup
        </TextWithIcon>
        <Buttons>
          <ModalTrigger modal={<SupportDialog />}>
            <Button
              data-test="sync-type-picker-header-icon-help"
              color="paper"
              level="secondary"
              size="xsmall">
              Help
            </Button>
          </ModalTrigger>
          <Button
            data-test="sync-type-picker-header-icon-close"
            eventElementName="SyncTypePicker-close"
            color="paper"
            level="secondary"
            size="xsmall"
            onClick={this.handleHideRequest}>
            Close
          </Button>
        </Buttons>
      </WizardHeader>
    );
  };

  renderOrgNameTitle = () => {
    const { orgName } = this.props;
    return (
      <React.Fragment>
        <Row size="xxsmall">
          <Text color="graphite" align="left">
            {orgName}
          </Text>
        </Row>
        <Row>
          <Heading levelStyle="1" align="left">
            SIS sync setup
          </Heading>
        </Row>
      </React.Fragment>
    );
  };

  displaySyncType = (syncType: SyncType) => {
    this.setState({ syncType: syncType });
  };

  handleHideRequest = () => {
    this.props.onClose();
  };

  renderDialogWithIconHeader = (body: React.ReactNode) => {
    return (
      <React.Fragment>
        {this.renderHeaderWithIcon()}
        <SyncSetupView>
          <Container className="AdminSyncTypePickerModal" size="large">
            {this.renderOrgNameTitle()}
            {body}
          </Container>
        </SyncSetupView>
      </React.Fragment>
    );
  };

  render() {
    const { selectSyncType, onClose } = this.props;

    const body =
      this.state.syncType === SyncType.clever ? (
        // Renders Clever
        <AdminSyncTypeCleverView
          selectSyncType={selectSyncType}
          onClose={onClose}
          displaySyncType={this.displaySyncType}
        />
      ) : (
        // Renders Classlink, OneRoster, CSV2.0, Aeries
        <AdminSyncTypePickerContainer
          selectSyncType={selectSyncType}
          onClose={onClose}
          displaySyncType={syncType => this.displaySyncType(syncType)}
          syncType={this.state.syncType}
        />
      );

    return (
      <Dialog box={true} full theme="light">
        {this.renderDialogWithIconHeader(body)}
      </Dialog>
    );
  }
}

export default AdminSyncTypePickerModal;
